import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ButtonDesign from "../../components/ButtonDesign/ButtonDesign";
import PortfolioCardFullMobile from "../../components/PortfolioCardFullMobile/PortfolioCardFullMobile";
import PortfolioCardFullWeb from "../../components/PortfolioCardFullWeb/PortfolioCardFullWeb";
import PortfolioEmpty from "../../components/PortfolioEmpty/PortfolioEmpty";

import "./PortfolioFullByType.css";

// SHOW ONLY 3 PROJECTS AS DEFAULT
const MINPROJECTS = 3;

const PortfolioFullByType = ({ data }) => {
	const { t } = useTranslation();
	const projects = data["projects"];
	var [fullPortfolio, setFullPortfolio] = useState(false);
	const [visibleProjects, setVisibleProjects] = useState([]);

	useEffect(() => {
		if (projects.length > MINPROJECTS) {
			setFullPortfolio(false);
			setVisibleProjects(projects.slice(0, MINPROJECTS));
		} else {
			setFullPortfolio(true);
			setVisibleProjects(projects);
		}
	}, [data]);

	const handleExtendPortfolio = (e) => {
		setFullPortfolio(true);
		setVisibleProjects(projects);
	};

	return (
		<div className="portfolio-full-by-type-bg">
			<div className="portfolio-full">
				<h1 className="portfolio-full-by-type-title">
					{data.title.title} <br /> {data.title.title2}{" "}
					{data.title.title3 && (
						<>
							<br />
							{data.title.title3}
						</>
					)}
				</h1>
				<h2 className="portfolio-full-by-type-subtitle">
					{data.title.subtitle}
				</h2>
				{visibleProjects.length > 0 ? (
					visibleProjects.map((project, index) => {
						return project["orientation"] === "HORIZONTAL" ? (
							<PortfolioCardFullWeb
								key={index}
								data={{
									id: index,
									title: project["titleBig"],
									subtitle: project["subtitle"],
									description: project["description"],
									paragraphs: project["paragraphs"],
									serviceType: project["service"],
									year: project["year"],
									techStack: project["techStack"],
									altFixed: project["altFixed"],
									altsCarousel: project["altsCarousel"],
									imagesCarousel: project["imagesCarousel"],
								}}
							/>
						) : (
							<PortfolioCardFullMobile
								key={index}
								data={{
									id: index,
									title: project["titleBig"],
									subtitle: project["subtitle"],
									description: project["description"],
									paragraphs: project["paragraphs"],
									serviceType: project["service"],
									year: project["year"],
									techStack: project["techStack"],
									altFixed: project["altFixed"],
									altsCarousel: project["altsCarousel"],
									imagesCarousel: project["imagesCarousel"],
								}}
							/>
						);
					})
				) : (
					<PortfolioEmpty />
				)}
				<div
					className={`${
						!fullPortfolio
							? "portfolio-full-by-type-button-visible"
							: "portfolio-full-by-type-button-invisible"
					}`}
				>
					<ButtonDesign
						data={{
							text: t("portfolio.buttonMore"),
							icon: true,
							dynamic: false,
						}}
						handleClick={() => handleExtendPortfolio()}
					/>
				</div>
			</div>
		</div>
	);
};

export default PortfolioFullByType;
